import { darken, getContrastRatio } from '@mui/material/styles'

/** Status badges keep white text readable even with a light configured theme color. */
export const badgeBackground = (themeColor: string) => {
  let background = themeColor
  for (let step = 0; step < 20 && getContrastRatio(background, '#fff') < 4.5; step += 1) {
    background = darken(background, .1)
  }
  return background
}
